import { useNavigate } from 'react-router-dom';
import { LogOut, Home, ChevronRight } from 'lucide-react';

export default function DashboardHeader({ email, onLogout }) {
  const navigate = useNavigate();

  return (
    <header className="bg-[#0d1b2e] border-b border-[#d4af37]/15 px-6 md:px-8 py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="font-['Cormorant_Garamond'] text-xl text-[#d4af37]">SitarMusic</span>
          <ChevronRight className="w-4 h-4 text-[#a3b1c6]/40" />
          <span className="text-[#a3b1c6] text-sm">Admin</span>
        </div>
        <div className="flex items-center gap-4">
          <button
            data-testid="admin-home-btn"
            onClick={() => navigate('/')}
            className="text-[#a3b1c6] hover:text-[#d4af37] transition-colors flex items-center gap-1.5 text-sm"
          >
            <Home className="w-4 h-4" /> Home
          </button>
          <span className="text-[#a3b1c6]/40">|</span>
          <span className="text-[#a3b1c6] text-sm">{email}</span>
          <button
            data-testid="admin-logout-btn"
            onClick={onLogout}
            className="text-[#a3b1c6] hover:text-red-400 transition-colors flex items-center gap-1.5 text-sm"
          >
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </div>
    </header>
  );
}
